// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import postTypeArchiveJobs from './routes/postTypeArchiveJobs';
import postTypeArchiveReports from './routes/postTypeArchiveReports';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Blog
  blog,
  // Jobs
  postTypeArchiveJobs,
  // Reports
  postTypeArchiveReports,
});

// Load Events
jQuery(document).ready(function () {
  routes.loadEvents();
});

window.addEventListener('load', () => {
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
});



// WEBPACK FOOTER //
// ./scripts/main.js